import { render, staticRenderFns } from "./DataDiri.vue?vue&type=template&id=b987062e"
import script from "./DataDiri.vue?vue&type=script&lang=js"
export * from "./DataDiri.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports